/**
 * Generates an empty array with the given number of items that can be iterated through.
 *
 * @param {number} num Number of elements.
 * @returns {undefined[]}
 */
export const range = (num) => Array.from(new Array(num));
